import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { clsx } from 'clsx';

import { ContentItem } from "./ContentItem";


export type ICtaProps = {
	
    title?: string;
	text?: string;
	ctaText: string;
	ctaLink: string;
    size?: 'half' | 'full';
};

export const Cta = (props: ICtaProps) => {
    
    return (
        <div className={clsx(
            props.size === 'full' ? "col-md-12 pt-12 pb-12" : "col-md-6 pt-6 pb-6",
            "align-self-center"
        )}>
            {
                props.title && <h1 className="secondfont mb-3 font-weight-bold">
                    {props.title}
                </h1>
            }
            {
                props.text && <ContentItem contentId="cta" text={props.text} ptClassName="mb-3" />
                
            }
            <a href={props.ctaLink} className="btn btn-dark" style={{ fontFamily: "ShadowsIntoLight", fontWeight: "bold"}}>
                { props.ctaText }
            </a>
        </div>		
	
	);
}
